import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Select } from '@mantine/core';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';

import { getConsumptionsSummary, getCostPPEByEstablishment } from '../../../../../slices/thunks';
import OChartCard from '../../../../../Components/OElements/OChartCard';
import OBarChart from '../../../../../Components/OElements/OBarChart';
import { ECHARTS_COLOR_PALETTE } from '../../../../../Components/Hooks/useColorArrayHooks';

const CompliancePPEByEstablishmentEChart = ({
    title,
    legendPosition = 'bottom',
    defaultFilters = {
        option: 'dia',
    },
    minHeight,
    maxHeight,
    companyId = null,
}) => {
    const dispatch = useDispatch();
    const [selectedDate, setSelectedDate] = useState(defaultFilters.option);
    const [selectedFuelType, setSelectedFuelType] = useState('diesel');

    // const selectorConsumptions = createSelector(
    //     state => state.FuelSupply,
    //     data => ({ info: data.consumptionsSummaryManagement || null })
    // );
    // const { info: infoConsumptions } = useSelector(selectorConsumptions);

    // const fetchConsumptionsData = useCallback(
    //     (filter, company_id) => {
    //         dispatch(
    //             getCostPPEByEstablishment({
    //                 // NO establishment_id here - this is for management view
    //                 filter: filter,
    //                 group: 'establecimiento', // Group by establishment
    //                 company_id: company_id, // Add company filter
    //             })
    //         );
    //     },
    //     [dispatch]
    // );

    const [infoConsumptions, setInfoConsumptions] = useState([]);

     const fetchConsumptionsData = useCallback(async (filter, company_id) => {
        const response = await dispatch(
            getCostPPEByEstablishment({
                // NO establishment_id here - this is for management view
                filter: filter,
                group: 'establecimiento', // Group by establishment
                company_id: company_id, // Add company filter
            })
        ).unwrap();

        console.log('repsonse!', response)

        setInfoConsumptions(response);
    }, [dispatch])

    useEffect(() => {
        fetchConsumptionsData(selectedDate, companyId);
    }, [selectedDate, companyId, fetchConsumptionsData]);

    // Dummy data (50 centros)
    const legendData = infoConsumptions.map(item => item._id)

    const costData = infoConsumptions.map(() => {
        return Math.floor(Math.random() * 101); // porcentaje random 0–100
    });

    console.log('costData porcentajes', costData)

    // Paleta de colores (se repite cada 10)

    // 🔹 Cada centro es una serie independiente
    const series = legendData.map((name, i) => ({
        name,
        type: 'bar',
        data: [costData[i]], // cada centro una barra
    }));

    const maxVisibleItems = 30;

    const endPercent = costData.length > maxVisibleItems
        ? (maxVisibleItems / totalItems) * 100
        : 100;

    const dataOptions = {
        tooltip: {
            trigger: 'item',
            formatter: function (params) {
                return (
                    '<b>Establecimiento:</b> ' + params.name + 
                    '<br/><b>Porcentaje de Cumplimiento:</b> ' + params.data.toLocaleString('es-CL') + '%'
                );
            },
        },
        legend: {
            data: legendData,
            orient: 'horizontal',
            bottom: 10,
            type: 'scroll',
        },
        grid: {
            left: 60,
            right: 60,
            top: 60,
            bottom: 60,
        },
        xAxis: {
            type: 'category',
            data: legendData,
            axisLabel: { 
                rotate: 50,
                interval: 0,
                textStyle: { fontSize: 12 },
                margin: 15
            },
            axisTick: { show: true },
            axisLine: { show: true },
        },
        yAxis: {
            type: 'value',
            axisLabel: {
                formatter: (v) => 
                    `${v.toLocaleString('es-CL')}%`,
            },
        },
        series: [
            {
                name: 'Costo',
                type: 'bar',
                data: costData,
                itemStyle: {
                    color: function (params) {
                        return ECHARTS_COLOR_PALETTE[1];
                    }
                }
            }
        ],
        ...(costData.length > maxVisibleItems && {
            dataZoom: [
                {
                    type: 'slider',
                    xAxisIndex: 0,
                    start: 0,
                    end: endPercent
                },
                {
                    type: 'inside',
                    xAxisIndex: 0,
                    start: 0,
                    end: endPercent
                }
            ]
        })
    };

    const options = useMemo(
        () => (dataOptions),
        [series, costData, legendData]
    );

    const [hasLoadedOnce, setHasLoadedOnce] = useState(false);
    const [hasValidData, setHasValidData] = useState(false);

    // useEffect(() => {
    //     if (Array.isArray(infoConsumptions?.data)) {
    //         setHasLoadedOnce(true);
    //         if (infoConsumptions.data.length > 0) {
    //             setHasValidData(true);
    //         }
    //     }
    // }, [infoConsumptions?.data]);

    // Only show empty state if we've loaded and confirmed there's no data
    // const noData = hasLoadedOnce && !infoConsumptions?.data?.length;

    const actions = (
        <div className='btn-box-dashboard' style={{ display: 'flex', gap: 8 }}>
            {/* <Select
                placeholder='Tipo de Combustible'
                data={[]}
                value={selectedFuelType}
                onChange={value => value && setSelectedFuelType(value)}
                size='xs'
                radius='lg'
                styles={{ input: { width: 150 } }}
                disabled={0}
            />
            <Select
                placeholder='Fecha'
                data={[
                    { label: 'Ciclo', value: 'ciclo' },
                    { label: 'Año', value: 'año' },
                    { label: 'Semestre', value: 'semestre' },
                    { label: 'Mes', value: 'mes' },
                    { label: 'Día', value: 'dia' },
                ]}
                value={selectedDate}
                onChange={value => value && setSelectedDate(value)}
                size='xs'
                radius='lg'
                styles={{ input: { width: 100 } }}
            /> */}
        </div>
    );

    return (
        <OChartCard
            title={title}
            actions={actions}
            isLoading={false}
            error={null}
            // isEmpty={noData}
            emptyIconClass='ri-gas-station-fill'
            emptyMessage='No cuenta con registro de consumo de combustible'
        >
            <OBarChart
                options={options}
                minHeight={minHeight}
                maxHeight={maxHeight}
            />
        </OChartCard>
    );
};

export default CompliancePPEByEstablishmentEChart;
// export default React.memo(CompliancePPEByEstablishmentEChart);
